/*
  FERROTECNIA — Cerrar el panel de categorías

  El panel se despliega con <details>, que funciona sin JavaScript y es lo
  correcto: abre y cierra desde el teclado y sigue sirviendo si el script falla.

  Lo que <details> no trae es lo que cualquiera espera de un desplegable ancho:
  que se cierre pulsando fuera o con Escape. Sin eso, quien lo abre se queda
  mirando doce categorías sin saber cómo volver — y no es que falte un botón de
  cerrar, es que el único que cierra es el mismo que abrió, cuatro filas más
  arriba y ya fuera de la vista en un panel alto.

  Esto lo añade encima, sin quitar nada: si el script no llega, el panel sigue
  abriendo y cerrando desde el botón como hasta ahora.

  Se escucha `pointerdown` y no `click` porque un clic sobre un enlace de otra
  parte de la página primero navega; con pointerdown el panel ya se ha cerrado
  cuando eso pasa.
*/
class PanelCategorias extends HTMLElement {
  constructor() {
    super();
    this.detalle = this.querySelector('details');
    this.boton = this.querySelector('summary');
    if (!this.detalle) return;

    this.alPulsarFuera = this.alPulsarFuera.bind(this);
    this.alTeclear = this.alTeclear.bind(this);

    this.detalle.addEventListener('toggle', () => {
      if (this.detalle.open) {
        // En el mismo tic todavía se está procesando el clic que lo abrió, y
        // ese clic saldría por `alPulsarFuera` cerrándolo al instante.
        requestAnimationFrame(() => this.escuchar());
      } else {
        this.dejarDeEscuchar();
      }
    });
  }

  escuchar() {
    document.addEventListener('pointerdown', this.alPulsarFuera);
    document.addEventListener('keydown', this.alTeclear);
  }

  dejarDeEscuchar() {
    document.removeEventListener('pointerdown', this.alPulsarFuera);
    document.removeEventListener('keydown', this.alTeclear);
  }

  alPulsarFuera(evento) {
    if (this.contains(evento.target)) return;
    this.cerrar();
  }

  alTeclear(evento) {
    if (evento.key !== 'Escape') return;
    this.cerrar();
    // Con Escape se devuelve el foco al botón: quien navega con teclado tiene
    // que quedarse donde estaba, no al principio de la página.
    if (this.boton) this.boton.focus();
  }

  cerrar() {
    this.detalle.open = false;
  }
}

if (!customElements.get('panel-categorias')) {
  customElements.define('panel-categorias', PanelCategorias);
}
